var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3402 16.4204C10.947 16.4315 10.5647 16.3029 10.2637 16.0582L6.54883 13.0394L2.83885 16.2686C2.53837 16.5302 2.15631 16.6805 1.76324 16.6916C1.5177 16.6986 1.28038 16.6527 1.05736 16.5553C0.470364 16.2986 0.0907345 15.714 0.0902022 15.0661L0.0805459 3.31253C0.0798993 2.52558 0.385637 1.777 0.941207 1.20457C1.49691 0.632266 2.23606 0.304768 3.02246 0.282496L10.0538 0.0833596C10.8403 0.0610837 11.58 0.3467 12.1366 0.88736C12.6932 1.42816 13.0001 2.15939 13.0007 2.94648L13.0104 14.7001C13.0109 15.348 12.6322 15.954 12.0456 16.244C11.8231 16.3542 11.5857 16.4134 11.3402 16.4204ZM6.54779 11.7664C6.67394 11.7629 6.80026 11.8025 6.90291 11.8858L10.973 15.1934C11.1394 15.3286 11.3821 15.354 11.5793 15.2566C11.779 15.158 11.9077 14.9518 11.9075 14.7313L11.8979 2.97785C11.8975 2.48559 11.7056 2.02828 11.3575 1.69005C11.0093 1.35182 10.5468 1.17314 10.0548 1.18707L3.02351 1.38621C2.53173 1.40014 2.06947 1.605 1.72191 1.96294C1.37435 2.32088 1.1831 2.78904 1.1835 3.28129L1.19316 15.0349C1.19334 15.2554 1.32241 15.4541 1.52212 15.5415C1.71949 15.6279 1.96225 15.5885 2.12813 15.444L6.19274 11.9059C6.29538 11.8168 6.42164 11.77 6.54779 11.7664Z",
    fill: "url(#paint0_linear_7299_5021)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7299_5021",
    x1: 6.5382,
    y1: 0.182926,
    x2: 7.00155,
    y2: 16.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark-icon.2c00c31902604579803b90fce911d0ca.svg";
export { ForwardRef as ReactComponent };